// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-templates-productlanding-page-js" + "-" + "c56babb089fa2f9780f3" + ".js";
};